import React, { FC } from 'react';
import st from "./navigation.module.scss"
import { HoverProvider, IconBox, Type as T } from "@infobis/ui-styles-utils";
import cn from "classnames";
import { NavItem } from '../menuToolbar/MenuToolbar';
import { NavLink } from "react-router-dom";
import { useWideScreen } from "@hooks/useWideScreen";
import colors from "@infobis/ui-styles-utils/colors";

interface Navigation {
    isFull?: boolean,
    navigation: NavItem[],
    onNavigationClick: (item: NavItem) => void
}

const Navigation: FC<Navigation> = (props) => {

    let {
        isFull, navigation
    } = props;

    const isWideScreen = useWideScreen()

    const renderNavItem = (item: NavItem) => {
        return (
            <HoverProvider key={item.path}>
                <NavLink
                    to={item.path}
                    className={({ isActive }) => cn(st.item, isActive ? st.currentPage : undefined)}
                >
                    {({ isActive }) => (
                        <div className={st.link}>
                            <IconBox
                                icon={item.icon}
                                color={isActive ? colors.CONTROL_PRIMARY_CONTENT : colors.CONTROL_DEFAULT_MAIN_MENU_ICON}
                                hoverColor={colors.CONTROL_PRIMARY_CONTENT}
                                size={T.Size.MEDIUM}
                                isWideScreenMode={isWideScreen}
                                sizePadding={T.Size.LARGE}
                                className={cn(st.icon, isActive ? st.currentPage : undefined)}
                            />
                            {isFull ?
                                <p className={cn(st.text, isActive ? st.currentPage : undefined)}>{item.name}</p> : null}
                        </div>
                    )}
                </NavLink>
            </HoverProvider>
        )
    }

    return (
        <div className={cn(st.list, isFull && st.list__full)}>
            {navigation.map(renderNavItem)}
        </div>
    )
}
export default Navigation;